import styled, { css } from 'styled-components';

export type GridProps = {
  rowGap?: number;
  columnGap?: number;
};

const COLUMNS_MOBILE = 2;
const COLUMNS_DESKTOP = 12;

const gridColumns = (columnsNumber: number, prefix: string) => {
  let styles = `
    grid-template-columns: repeat(${columnsNumber}, 1fr);

    > * {
      grid-column: span ${columnsNumber} / span ${columnsNumber};
    }`;

  for (let i = 1; i <= columnsNumber; i += 1) {
    styles += `
    > .grid-span-${prefix}-${i},
      .span-${prefix}-${i} {
      grid-column: span ${i} / span ${i};
    }
    > .grid-start-${prefix}-${i} {
      grid-column-start: ${i};
    }
     `;
  }

  return /*#__PURE__*/ css`
    ${styles}
  `;
};

export const Grid = styled.div<GridProps>`
  display: grid;
  ${({ columnGap }) =>
    columnGap
      ? css`
          grid-column-gap: ${columnGap * 16}px;
        `
      : css`
          grid-column-gap: 16px;
        `}
  ${({ rowGap }) =>
    rowGap
      ? css`
          grid-row-gap: ${rowGap * 8}px;
        `
      : null}
  ${gridColumns(COLUMNS_MOBILE, 'mobile')}
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    ${gridColumns(COLUMNS_DESKTOP, 'desktop')}
  }
`;
